<template>
  <div class="app-main-content tab-voyage">
    <div class="grid-view">
      <div
        v-show="showMainList"
        class="main-content"
        type="primary"
      >
        <div style="height: auto;width: 100%;margin-top: 5px;" class="cargo-advance-search">
          <div class="section cargo-advance-search-more">
            <el-form
              label-position="left"
              class="cargo-advance-search-form"
              :label-width="$selectByLang('80px', '80px', '80px', '120px', '120px', '120px')"
              style="min-width: 830px;margin-right: 10px;"
              :inline="true"
            >
              <el-form-item :label="$t('SeaExport.Vessel')">
                <cargo-advance-select
                  :disabled="isEdit"
                  filterable
                  clearable
                  :select-type="selectTypeNames.basic_data_Vessel"
                  tag-name="englishName"
                  tag-value="vesselId"
                  style="width: 200px"
                  :default-value="filter.vesselId"
                  no="1"
                  @parentCallBack="vesselChange"
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div style="width:100%; height: 100%; overflow:hidden">
          <div class="section grid-wrapper" style="float:left; height: 100%; width:30%;">
            <cargo-ag-grid
              :grid-params.sync="voyage.gridParams"
              :grid-options="voyage.gridOptions"
              :column-defs="voyageColumnDefs"
              :show-side-bar="false"
              :row-data="voyage.rowData"
              @gridReady="params=>{voyage.gridOptions.gridApi=params.api}"
            />
            <div class="app-main-inner-row row-pagination">
              <cargo-pagination
                config-module="3106888"
                :total="filter.total"
                :page.sync="filter.pageNum"
                :limit.sync="filter.pageSize"
                @pagination="toQuery"
              />
            </div>
            <div style="margin: 0; padding: 0; width: 100%">
              <div style="float: right; margin: 10px">
                <el-checkbox v-model="copyShip" no="virtualHBL" style="margin-left: -20px;">{{ $t('SeaExport.CopyShip') }}</el-checkbox>
                <el-button v-if="!isEdit" :disabled="!filter.vesselId" style="margin-left: 10px; width: 60px" type="primary" no="2" @click="onAddVoyage">
                  {{ $t('SeaExport.Add') }}
                </el-button>
                <el-button v-if="!isEdit" style="margin-left: 10px; width: 60px" type="primary" :disabled="!hasChooseVoyage" no="3" @click="onEditVoyage">
                  {{ $t('SeaExport.Edit') }}
                </el-button>
                <el-button v-if="!isEdit" style="margin-left: 10px; width: 60px" type="danger" :disabled="!hasChooseVoyage" no="4" @click="onRemoveVoyage">
                  {{ $t('SeaExport.Delete') }}
                </el-button>
                <el-button v-if="isEdit" style="margin-left: 10px; width: 60px" type="primary" no="5" @click="onSaveVoyage">
                  {{ $t('SeaExport.Save') }}
                </el-button>
                <el-button v-if="isEdit" style="margin-left: 10px; width: 60px" type="primary" no="6" @click="onCancelVoyage">
                  {{ $t('SeaExport.Cancel') }}
                </el-button>
              </div>
            </div>

          </div>
          <div class="section grid-wrapper" style="float:right; height: 100%; width:69%;">
            <cargo-ag-grid
              :grid-params.sync="segment.gridParams"
              :grid-options="segment.gridOptions"
              :column-defs="segmentColumnDefs"
              :show-side-bar="false"
              :row-data="segment.rowData"
              @gridReady="params=>{segment.gridOptions.gridApi=params.api}"
            />
            <div v-if="isEdit" style="margin: 0; padding: 0; width: 100%">
              <div style="float: right; margin: 10px">
                <el-button style="margin-left: 10px; width: 60px" type="primary" no="7" @click="onAddSegment">
                  {{ $t('SeaExport.IncreaseThePort') }}
                </el-button>
                <el-button style="margin-left: 10px; width: 60px" type="primary" no="8" @click="onRemoveSegment">
                  {{ $t('SeaExport.DeletePorts') }}
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { queryVoyages, getSegments, saveVoyages, delVoyage } from '@/api/voyage'
import { queryLastFileDocumentId } from '@/api/seaExport/businessDocument'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import CargoAgGridDateTimeEditor from '@/components/Cargo/Common/CargoAgGridDateTimeEditor/index'
import StrUtils from '@/utils/StrUtils'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import ImportResult from '@/views/cargo/v0/SeaExport/Vessel/components/importResult'
import URL from '@/api/urlTranslator'
import { cache } from '@/utils/cacheManager'
import DateUtils from '@/utils/dateUtils'
import { getObjectByCache } from '@/utils/basicDataCache'
import { getVesselCarriers } from '@/api/vessel'

export default {
  name: 'TabVoyage',
  components: { ImportResult, CargoAdvanceSelect },
  data() {
    return {
      URL,
      selectTypeNames: TYPE_NAMES,
      storageURL: '',
      showDetail: false,
      hasChooseVoyage: false,
      delSegmentRows: [], // 删除的数据缓存
      importResultDialog: {
        visible: false,
        result: {}
      },
      copyShip: true,
      voyage: {
        gridParams: {},
        gridOptions: {
          suppressCellSelection: true,
          rowSelection: 'single',
          // 添加编辑组件
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor
          },
          onRowClicked: this.onRowClickedEvent,
          gridApi: null
        },
        rowData: [],
        originData: [],
        selectedRow: null, // 单击选中的行数据
        selectedIndex: -1
      },
      segment: {
        gridParams: {},
        gridOptions: {
          suppressCellSelection: true,
          rowSelection: 'single',
          // 添加编辑组件
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonInputEditor,
            CargoAgGridDateTimeEditor
          },
          // 单击显示编辑
          singleClickEdit: true,
          onRowClicked: this.onSegmentRowClickedEvent,
          gridApi: null
        },
        rowData: [],
        selectedRow: null,
        selectedIndex: -1
      },
      isEdit: false,
      isAdd: false,
      fullscreenLoading: null,
      filter: {
        pageNum: 1,
        pageSize: 50,
        total: 0
      },
      voyageColumnDefs: [
        {
          headerName: this.$t('SeaExport.Voyage'), field: 'voyageNo', colId: 'voyageNo', width: 200,
          editable: (params) => { return (this.isEdit && params.data.masterCarrier) },
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          cellEditor: 'CargoAgGridCommonInputEditor'
        },
        {
          headerName: this.$t('SeaExport.Vessel'), field: 'vesselId', colId: 'vesselId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Vessel, 'vesselId', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AirlineCode'), field: 'routeCode', colId: 'routeCode', width: 200,
          editable: () => { return this.isEdit },
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          cellEditor: 'CargoAgGridCommonInputEditor'
        },
        {
          headerName: this.$t('SeaExport.ShippingCompany'), field: 'carrierId', colId: 'carrierId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, this.language)
          },
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          editable: () => { return false },
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Company,
              tagName: this.language,
              tagValue: 'cmpIdx',
              methodParams: { active: true, seaCmp: true },
              filterable: true,
              clearable: true
            }
          }
        },
        {
          headerName: this.$t('SeaExport.InternalVoy'), field: 'internalVoy', colId: 'internalVoy', width: 200,
          editable: () => { return this.isEdit },
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          cellEditor: 'CargoAgGridCommonInputEditor'
        }
      ],
      segmentColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_Port'), field: 'portOfCall', colId: 'portOfCall', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Seaport,
              tagName: 'englishName',
              tagValue: 'code',
              filterable: true,
              clearable: true
            }
          },
          editable: () => { return this.isEdit },
          onCellValueChanged: (params) => {
            this.segmentOnCellChange(params)
          }
        },
        {
          headerName: this.$t('SeaExport.HarborDistrict'), field: 'berth', colId: 'berth', width: 100,
          editable: () => { return this.isEdit },
          onCellValueChanged: (params) => {
            this.segmentOnCellChange(params)
          },
          cellEditor: 'CargoAgGridCommonInputEditor'
        },
        {
          headerName: 'Original ETA', field: 'eta', colId: 'eta', width: 100,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          editable: () => { return this.isEdit },
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'datetime',
              format: 'yyyy-MM-dd HH:mm ',
              valueFormat: 'yyyy-MM-dd HH:mm'
            }
          },
          onCellValueChanged: (params) => {
            this.segmentOnCellChange(params)
          }
        },
        {
          headerName: 'Original ETD', field: 'etd', colId: 'etd', width: 100,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          editable: () => { return this.isEdit },
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'datetime',
              format: 'yyyy-MM-dd HH:mm',
              valueFormat: 'yyyy-MM-dd HH:mm'
            }
          },
          onCellValueChanged: (params) => {
            this.segmentOnCellChange(params)
          }
        },
        {
          headerName: 'ATD', field: 'atd', colId: 'atd', width: 100,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          editable: () => { return this.isEdit },
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'datetime',
              format: 'yyyy-MM-dd HH:mm',
              valueFormat: 'yyyy-MM-dd HH:mm'
            }
          },
          onCellValueChanged: (params) => {
            this.segmentOnCellChange(params)
          }
        },
        {
          headerName: this.$t('SeaExport.ShipsCallSign'), field: 'ediCode', colId: 'ediCode', width: 100,
          editable: () => { return this.isEdit },
          onCellValueChanged: (params) => {
            this.segmentOnCellChange(params)
          },
          cellEditor: 'CargoAgGridCommonInputEditor'
        },
        {
          headerName: 'ATA', field: 'ata', colId: 'ata', width: 100,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          editable: () => { return this.isEdit },
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'datetime',
              format: 'yyyy-MM-dd HH:mm',
              valueFormat: 'yyyy-MM-dd HH:mm'
            }
          },
          onCellValueChanged: (params) => {
            this.segmentOnCellChange(params)
          }
        },
        {
          headerName: 'Current ETA', field: 'currentEta', colId: 'currentEta', width: 100,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          editable: () => { return this.isEdit },
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'datetime',
              format: 'yyyy-MM-dd HH:mm',
              valueFormat: 'yyyy-MM-dd HH:mm'
            }
          },
          onCellValueChanged: (params) => {
            this.segmentOnCellChange(params)
          }
        },
        {
          headerName: 'Current ETD', field: 'currentEtd', colId: 'currentEtd', width: 100,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          editable: () => { return this.isEdit },
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'datetime',
              format: 'yyyy-MM-dd HH:mm',
              valueFormat: 'yyyy-MM-dd HH:mm'
            }
          },
          onCellValueChanged: (params) => {
            this.segmentOnCellChange(params)
          }
        },
        {
          headerName: this.$t('SeaExport.DocCutOffDate'), field: 'fileCutoff', colId: 'fileCutoff', width: 100,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          editable: () => { return this.isEdit },
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'datetime',
              format: 'yyyy-MM-dd HH:mm',
              valueFormat: 'yyyy-MM-dd HH:mm'
            }
          },
          onCellValueChanged: (params) => {
            this.segmentOnCellChange(params)
          }
        },
        {
          headerName: this.$t('SeaExport.CYCutOffDate'), field: 'terminalCutoff', colId: 'terminalCutoff', width: 100,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          editable: () => { return this.isEdit },
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'datetime',
              format: 'yyyy-MM-dd HH:mm',
              valueFormat: 'yyyy-MM-dd HH:mm'
            }
          },
          onCellValueChanged: (params) => {
            this.segmentOnCellChange(params)
          }
        },
        {
          headerName: this.$t('SeaExport.CYCutOffDate2'), field: 'customCutoff', colId: 'customCutoff', width: 100,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          editable: () => { return this.isEdit },
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'datetime',
              format: 'yyyy-MM-dd HH:mm',
              valueFormat: 'yyyy-MM-dd HH:mm'
            }
          },
          onCellValueChanged: (params) => {
            this.segmentOnCellChange(params)
          }
        }
      ]
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    language() {
      return this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'
    },
    sessionId() {
      return this.$store.getters.token
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.storageURL = cache.config.get('StorageURL')
    },
    async onAddVoyage() {
      this.voyage.selectedIndex = 0
      this.isEdit = true
      this.isAdd = true
      const vessel = getObjectByCache(TYPE_NAMES.basic_data_Vessel, 'vesselId', this.filter.vesselId)
      console.log('vessel', vessel)
      const masterVoyage = { vesselId: this.filter.vesselId, carrierId: vessel.carrierId, segments: [], masterCarrier: true }
      console.log('masterVoyage', masterVoyage)
      let vesselCarriers = []
      await getVesselCarriers({ vesselUuid: vessel.uuid }).then(res => {
        vesselCarriers = res.data
      })
      this.voyage.rowData = []
      this.voyage.rowData.push(masterVoyage)
      if (vesselCarriers) {
        for (const vesselCarrier of vesselCarriers) {
          const voyage = { vesselId: this.filter.vesselId, carrierId: vesselCarrier.carrierId, segments: [] }
          console.log('voyage', voyage)
          this.voyage.rowData.push(voyage)
        }
      }
      this.voyage.selectedRow = masterVoyage
      this.segment.rowData = []
      console.log('this.voyage.rowData', this.voyage.rowData)
      this.voyage.gridOptions.api.setFocusedCell(this.voyage.selectedIndex)
    },
    async onEditVoyage() {
      if (!this.voyage.selectedRow) {
        return
      }
      const voyageNo = this.voyage.selectedRow.voyageNo
      const rowData = this.voyage.rowData.filter(c => c.voyageNo === voyageNo)
      const vessel = getObjectByCache(TYPE_NAMES.basic_data_Vessel, 'vesselId', this.filter.vesselId)
      let vesselCarriers = []
      await getVesselCarriers({ vesselUuid: vessel.uuid }).then(res => {
        vesselCarriers = res.data
      })
      // 如果编辑的时候，将没维护的共舱航司的数据新增进来
      for (const vesselCarrier of vesselCarriers) {
        let exist = false
        for (const voyageData of rowData) {
          if (vesselCarrier.carrierId === voyageData.carrierId) {
            exist = true
          }
        }
        if (!exist) {
          const voyage = { vesselId: this.filter.vesselId, carrierId: vesselCarrier.carrierId, segments: [], voyageNo: voyageNo }
          rowData.push(voyage)
        }
      }
      // 更新主船司的船司数据
      let notMaster = true
      for (const row of rowData) {
        if (row.masterCarrier) {
          row.carrierId = vessel.carrierId
          notMaster = false
        }
      }
      if (notMaster) {
        const voyage = { vesselId: this.filter.vesselId, carrierId: vessel.carrierId, segments: [], masterCarrier: true }
        rowData.push(voyage)
      }
      // 将rowData重新排序，将masterCarrier = true的数据排在集合最上方
      rowData.sort((a, b) => {
        if (a.masterCarrier && !b.masterCarrier) return -1
        if (!a.masterCarrier && b.masterCarrier) return 1
        return 0
      })
      this.voyage.rowData = rowData
      this.isEdit = true
      // 选中第一行
      if (this.voyage.rowData.length > 0) {
        // 设置选中的行数据和索引
        this.voyage.selectedRow = this.voyage.rowData[0]
        this.voyage.selectedIndex = 0
        this.hasChooseVoyage = true
        // 同步刷新segment数据
        this.segment.rowData = this.voyage.rowData[0].segments || []
        // 等待下一个tick确保grid已经渲染完成
        this.$nextTick(() => {
          // 设置ag-grid的焦点和选中状态
          if (this.voyage.gridOptions.api) {
            this.voyage.gridOptions.api.setFocusedCell(0, 'voyageNo')
            this.voyage.gridOptions.api.selectIndex(0, false, false)
          }
          // 刷新segment的ag-grid
          if (this.segment.gridOptions.api) {
            this.segment.gridOptions.api.setRowData(this.segment.rowData)
          }
        })
      }
    },
    onRemoveVoyage() {
      if (this.voyage.selectedRow) {
        this.fullscreenLoading = getLoading()
        const delSegmentRows = []
        const delVoyageUuid = []
        let voyageList = []
        // 如果主航司删了，共舱航司也一起删除
        if (this.voyage.selectedRow.masterCarrier) {
          voyageList = this.voyage.rowData.filter(c => c.voyageNo === this.voyage.selectedRow.voyageNo)
        } else {
          voyageList.push(this.voyage.selectedRow)
        }
        for (const voyage of voyageList) {
          delVoyageUuid.push(voyage.uuid)
          for (const segment of voyage.segments) {
            delSegmentRows.push(segment.uuid)
          }
        }
        delVoyage({ delVoyageUuid, delSegmentRows }).then(res => {
          this.$message.success(this.$t('Message.DeleteSuccessfully'))
          this.voyage.selectedRow = null
          this.onCancelVoyage()
          this.fullscreenLoading.close()
        }).catch(() => {
          this.fullscreenLoading.close()
        })
      }
    },
    onSaveVoyage() {
      // 获取航次变更的数据
      const updateVoyages = this.voyage.rowData
      let masterVoyage = null
      for (const item of this.voyage.rowData) {
        if (StrUtils.isEmpty(item.voyageNo)) {
          this.$message.warning(this.$t('SeaExport.VOYAGE_NUMBER_ALERT'))
          return
        }
        // 判断是否有港口为空，或者港口重复的情况
        if (item.segments) {
          const set = new Set()
          for (const segment of item.segments) {
            if (set.has(segment.portOfCall)) {
              this.$message.warning(this.$t('SeaExport.PortDuplication'))
              return
            } else {
              set.add(segment.portOfCall)
            }
            if (StrUtils.isEmpty(segment.portOfCall)) {
              this.$message.warning(this.$t('SeaExport.PortNotNull'))
              return
            }
            if (!segment.etd && !segment.eta) {
              this.$message.warning(this.$t('SeaExport.EtdAndEtaNotNull'))
              return
            }
          }
        }
        if (item.masterCarrier) {
          masterVoyage = item
        }
      }
      // 勾选情况下，共舱船司中的的航次详情信息全部同步抽主航司的航次详情
      if (this.copyShip && masterVoyage) {
        for (const item of this.voyage.rowData) {
          if (item.masterCarrier) {
            continue
          }
          console.log('item', item)
          for (const segment of item.segments) {
            if (segment.uuid) {
              this.delSegmentRows.push(segment.uuid)
            }
          }
          // 将主船司的复制一份
          item.segments = JSON.parse(JSON.stringify(masterVoyage.segments))
          for (const segment of item.segments) {
            // 将uuid清空
            segment.uuid = ''
            segment.voyageUuid = item.uuid
          }
          console.log('item.segments', item.segments)
        }
      }
      this.fullscreenLoading = getLoading()
      const { delSegmentRows, isAdd } = this
      for (const item of this.voyage.originData) {
        for (const voyage of updateVoyages) {
          if (item.uuid !== voyage.uuid && item.masterCarrier && voyage.masterCarrier && item.voyageNo === voyage.voyageNo) {
            this.$message.warning(this.$t('CargoMsg.Cargo_DuplicateLaneCodePleaseTryItAgain'))
            this.fullscreenLoading.close()
            return
          }
        }
      }
      saveVoyages({ updateVoyages, delSegmentRows, isAdd, branchId: this.$store.getters.currentOfficeId }).then(res => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.onCancelVoyage()
        this.fullscreenLoading.close()
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    onCancelVoyage() {
      // 新增状态取消需删除新增记录
      this.isEdit = false
      this.isAdd = false
      this.hasChooseVoyage = false
      this.voyage.gridOptions.api.clearFocusedCell()
      this.clearSegmentTemp()
      // 重新加载该船名的数据
      this.toQuery()
    },
    onAddSegment() {
      const newSegment = {
        voyageUuid: this.voyage.selectedRow['uuid']
      }
      this.segment.rowData.push(newSegment)
      this.segment.gridOptions.gridApi.refreshCells({ force: true })
    },
    onRemoveSegment() {
      const api = this.segment.gridOptions.api
      if (!this.segment.selectedRow) {
        return
      }
      if (this.segment.selectedRow.uuid) { // 删除数据缓存
        this.delSegmentRows.push(this.segment.selectedRow.uuid)
      }
      this.segment.rowData.splice(this.segment.selectedIndex, 1) // 删除第一行数据
      api.setRowData(this.segment.rowData)
    },
    vesselChange(p) {
      const value = p.value
      if (StrUtils.isEmpty(value)) {
        this.filter.vesselId = value
        this.voyage.rowData = []
        this.voyage.originData = []
        this.segment.rowData = []
        return
      }
      if (value && this.filter.vesselId !== value) {
        this.filter.vesselId = value
        this.clearSegmentTemp() // 切换时清除数据缓存
        this.hasChooseVoyage = false
        this.voyage.gridOptions.api.clearFocusedCell()
        this.toQuery()
      }
    },
    toQuery() {
      this.segment.rowData = []
      if (!this.filter.vesselId) {
        return
      }
      this.fullscreenLoading = getLoading()
      queryVoyages({ pageSize: this.filter.pageSize, pageNum: this.filter.pageNum, vesselId: this.filter.vesselId }).then(res => {
        this.voyage.rowData = res.data.list
        this.voyage.originData = res.data.list
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.filter.total = Number(res.data.total)
        this.fullscreenLoading.close()
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    onSegmentRowClickedEvent(e) {
      const data = e.data
      this.segment.selectedRow = data
      this.segment.selectedIndex = e.rowIndex
    },
    onRowClickedEvent(e) {
      this.hasChooseVoyage = true
      this.segment.selectedRow = null
      this.segment.selectedIndex = -1
      const data = e.data
      console.log('data', data)
      this.voyage.selectedRow = data
      this.voyage.selectedIndex = e.rowIndex
      this.segment.rowData = data.segments
    },
    // 清除航次明细的缓存数据
    clearSegmentTemp() {
      this.segment.selectedRow = null
      this.segment.selectedIndex = -1
      this.delSegmentRows = []
    },
    onCellChange(params) {
      const field = params.colDef.field
      const newValue = params.newValue
      const data = params.data
      // 如果更改是的主船司，那么下面共舱航司的数据也一起更改
      if (field === 'voyageNo' || (data.masterCarrier && this.copyShip)) {
        for (const voyage of this.voyage.rowData) {
          voyage[field] = newValue
        }
        this.voyage.gridOptions.gridApi.refreshCells({ force: true })
      }
    },
    segmentOnCellChange(params) {
      const field = params.colDef.field
      const data = params.data
      const newValue = params.newValue
      this.dateLinkageLogic(field, data, newValue)
    },
    fetchOrderRequirement() {
    },
    // 时间联动逻辑
    dateLinkageLogic(field, data, newValue) {
      if (field === 'currentEta' && !data.currentEtd) {
        data.currentEtd = DateUtils.addHours(newValue, 12)
      } else if (field === 'currentEtd' && !data.currentEta) {
        data.currentEta = DateUtils.addHours(newValue, -12)
      } else if (field === 'eta' && !data.etd) {
        data.etd = DateUtils.addHours(newValue, 12)
      } else if (field === 'etd' && !data.eta) {
        data.eta = DateUtils.addHours(newValue, -12)
      } else if (field === 'ata' && !data.atd) {
        data.atd = DateUtils.addHours(newValue, 12)
      } else if (field === 'atd' && !data.ata) {
        data.ata = DateUtils.addHours(newValue, -12)
      }
      this.segment.gridOptions.gridApi.applyTransaction({ update: [data] })
    }
  }
}
</script>

<style scoped>

</style>
